<template>
	<transition name="slide-fade">
		<div class="modal-container">
			<div class="modal" @click.stop>
				<div class="modal-header">
					<div class="modal-title">
						<span>Attention!</span>
					</div>
					<div class="close" title="close">
						<ion-icon name="ios-close" @click="closeModal"></ion-icon>
					</div>
				</div>
				<div class="modal-body">
					<p>
						Are you sure you want to unfollow
						<i>@</i>
						{{userToUnfollow.username}}?
					</p>
					<p>Unfollowing this user will remove their stories from your stack.</p>
				</div>
				<br />
				<div class="modal-footer">
					<button class="button delete-button" id="unfollow-user" @click="unfollowUser">Yes, Unfollow</button>
					<button class="button stackng-button" @click="closeModal">No</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import { db } from "../../resources/firebase";
import firebase from "firebase/app";
import "firebase/firestore";

export default {
	mounted() {
		const modalContainer = document.querySelector(".modal-container");
		modalContainer.addEventListener("click", this.closeModal);
	},
	computed: {
		userToUnfollow() {
			return this.$store.getters.getUnfollowModal.user;
		},
		authUserView() {
			return (
				this.$store.state.user.user.username === this.$route.params.username
			);
		}
	},
	methods: {
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			let payload = {
				show: false,
				user: {}
			};
			this.$store.commit("updateUnfollowModal", payload);
		},
		unfollowUser() {
			const unfollowButton = document.querySelector("#unfollow-user");
			unfollowButton.classList.add("is-loading");
			let authUserID = this.$store.state.user.authUser.uid;
			let followersCount = 0;
			let followingCount = 0;

			db.collection("users")
				.where("userID", "==", this.userToUnfollow.userID)
				.get()
				.then(snapshot => {
					//Get followersCount
					snapshot.forEach(doc => {
						followersCount = doc.data().followers.length;
						followingCount = doc.data().following.length;
					});
				})
				.then(() => {
					//Unfollow user
					db.collection("users")
						.doc(this.userToUnfollow.userID)
						.update({
							followers: firebase.firestore.FieldValue.arrayRemove(authUserID),
							followersCount: followersCount - 1
						})
						.then(() => {
							//Remove from userView followers state
							if (
								this.userToUnfollow.username === this.$route.params.username
							) {
								this.$store.commit("removeUserFollowers", authUserID);
							} else if (this.authUserView) {
								this.$store.commit(
									"removeAuthUserFollowing",
									this.userToUnfollow.userID
								);
							}

							//Remove from authUsers following
							db.collection("users")
								.doc(authUserID)
								.update({
									following: firebase.firestore.FieldValue.arrayRemove(
										this.userToUnfollow.userID
									),
									followingCount: followingCount - 1
								})
								.then(() => {
									this.$toasted.show(
										`Unfollowed ${this.userToUnfollow.username}`,
										{
											theme: "bubble",
											position: "bottom-center",
											duration: 1500
										}
									);

									setTimeout(() => {
										unfollowButton.classList.remove("is-loading");
										this.closeModal();
									}, 500);
								})
								.catch(error => {
									// console.log(error);
									throw new Error(error);
								});
						})
						.catch(error => {
							// console.log(error);
							throw new Error(error);
						});
				})
				.catch(error => {
					// console.log(error);
					throw new Error(error);
				});
		}
	}
};
</script>

<style lang="css" src="../../styles/modalStyles.css" scoped></style>
<!--<style lang="scss" scoped>
     @import "../../styles/modalStyles.scss";
</style>-->
<style scoped>
.modal-body,
.modal-footer {
	text-align: center;
}

.modal-body p:first-of-type {
	font-size: 23px;
	font-weight: bold;
	line-height: 1.1;
}

.modal-body p:last-of-type {
	font-size: 15px;
	color: #b7b7b7;
}

.modal-footer {
	height: 25%;
}

i {
	color: #51c715;
	font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/UnfollowModal.vue